module.exports = __webpack_public_path__ + "static/media/view1.1b41d031.jpg";